import { put, takeEvery, call } from "redux-saga/effects";
import * as actionTypes from "./constants";
// import { appConfig } from "../../config";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import endpoints from "../endpoints";
// import api from "../api";
import fmApi from "../APIWrapper";

// function* commonFunction(value) {
//   const token = localStorage.getItem("fmsToken");
//   try {
//     const res = yield fetch(`${value.api}`, {
//       method: `${value.method}`,
//       headers: {
//         Accept: "application/json",
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${token}`,
//         type:'Web'
//       },
//       body: value.body ? value.body : null,
//     });
//     if (!res.ok) {
//       throw res;
//     } else {
//       const resJSON = yield res.json();

//       yield put({
//         type: `${value.sucessAction}`,
//         payload: resJSON,
//       });
//       yield put({ type: `${value.initAction}` });

//       yield toast.success(value.toastMsg, {
//         autoClose: 3000,
//       });
//       return resJSON;
//     }
//   } catch (err) {
//     if (err.ok === false) {
//       yield put({ type: `${value.failAction}`, error: err });
//     } else {
//     }
//   }
// }

// function* commonPostFunction(value) {
//   const token = localStorage.getItem("fmsToken");
//   try {
//     const res = yield fetch(`${value.api}`, {
//       method: `${value.method}`,
//       headers: {
//         Accept: "application/json",
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${token}`,
//         type: "Web",
//       },
//       body: value.body ? value.body : null,
//     });
//     if (!res.ok) {
//       throw res;
//     } else {
//       const resJSON = yield res.json();
//       yield put({
//         type: `${value.sucessAction}`,
//         payload: resJSON,
//       });
//       yield put({
//         type: `${value.initAction}`,
//       });
//       yield toast.success(value.toastMsg, {
//         autoClose: 3000,
//       });
//       return resJSON;
//     }
//   } catch (err) {
//     if (err.ok === false) {
//       if (err.status === 400) {
//         yield put({ type: `${value.failAction}`, error: err });
//         yield toast.error(`${endpoints.status400}`, {
//           autoClose: 3000,
//         });
//       } else if (err.status === 500) {
//         yield put({ type: `${value.failAction}`, error: err });
//         yield toast.error(`${endpoints.status500}`, {
//           autoClose: 3000,
//         });
//       } else {
//       }
//     }
//   }
// }

function* addOnboardingTwo(value) {
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  const ownerMobileno =
    value?.value?.ownerIsd + "-" + value?.value?.ownerMobileno || "";
  const residentMobileno =
    value?.value?.resIsd + "-" + value?.value?.residentMobileno || "";
  const data = {
    societyId: `${fmsUser.society_id}`,
    apts: [
      {
        aptNo: value?.value?.ApartmentNo || "",
        residentName: value?.value?.ResidentName || "",
        residentEmail: value?.value?.ResidentEmail || "",
        residentPhone: residentMobileno || "",
        towerName: `${value?.value?.towerName}`,
        ownerName:
          value?.value?.ownerName === ""
            ? value.value.ResidentName
            : value?.value?.ownerName,
        ownerEmail:
          value?.value?.ownerEmail === ""
            ? value?.value?.ResidentEmail
            : value?.value?.ownerEmail,
        ownerPhone: ownerMobileno === "91-" ? residentMobileno : ownerMobileno,
      },
    ],
  };
  try {
    // let params = {
    //   api: `${appConfig.urlPrefixIp}/apartmentinfoservice/society/addaptdetails`,
    //   method: "POST",
    //   sucessAction: actionTypes.ADD_ONBOARDINGTWO_SUCCESS_ACTION,
    //   toastMsg: "Onboarded successfully",
    //   failAction: actionTypes.ADD_ONBOARDINGTWO_FAIL_ACTION,
    //   body: JSON.stringify(data),
    // };
    // const Res = yield call(commonPostFunction, params);
    // return Res;
    const resJSON = yield call(fmApi.UpdateAppUsersApi, data);

    yield put({
      type: actionTypes.ADD_ONBOARDINGTWO_SUCCESS_ACTION,
      payload: resJSON,
    });

    yield toast.success("Onboarded successfully", {
      autoClose: 3000,
    });
    return resJSON;
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.ADD_ONBOARDINGTWO_FAIL_ACTION,
        error: err,
      });
      if (err.status === 400) {
        yield toast.error(`${endpoints.status400}`, {
          autoClose: 3000,
        });
      } else if (err.status === 500) {
        yield toast.error(`${endpoints.status500}`, {
          autoClose: 3000,
        });
      } else {
      }
    }
  }
}

function* fetchOnboardingTwo() {
  const data = {
    token: "f08d43cd4f9742399e5ab9c98b724998",
  };
  try {
    // let params = {
    //   api: `${appConfig.urlPrefixIp}/societydataservice/society/getsoc`,

    //   method: "POST",
    //   sucessAction: actionTypes.FETCH_ONBOARDINGTWO_SUCCESS_ACTION,
    //   failAction: actionTypes.FETCH_ONBOARDINGTWO_FAIL_ACTION,
    //   body: JSON.stringify(data),
    // };
    // const Res = yield call(api.commonGetFunction, params);
    // return Res;
    const resJSON = yield call(fmApi.FetchSocApi, data);

    yield put({
      type: actionTypes.FETCH_ONBOARDINGTWO_SUCCESS_ACTION,
      payload: resJSON,
    });
    // }
  } catch (err) {
    if (err.status === 401) {
    }
    yield put({
      type: actionTypes.FETCH_ONBOARDINGTWO_FAIL_ACTION,
      payload: err,
    });
  }
}

export function* onboardingtwoActionWatcher() {
  yield takeEvery(actionTypes.ADD_ONBOARDINGTWO_INIT_ACTION, addOnboardingTwo);
  yield takeEvery(
    actionTypes.FETCH_ONBOARDINGTWO_INIT_ACTION,
    fetchOnboardingTwo
  );
}
